'use client';

import { NotificationMessage } from '@cmbg-traky-web/design-system';
import React from 'react';

interface ErrorOverlayProps {
  icon?: string;
  title?: string;
  text?: string;
  primaryCallback?: () => void;
  secondaryCallback?: () => void;
  primaryText?: string;
  secondaryText?: string;
}

/**
 * Componente reutilizable para mostrar errores como overlay.
 * Se usa en ErrorBoundaryContext, error.tsx, not-found.tsx, etc.
 */
export const ErrorOverlay: React.FC<ErrorOverlayProps> = ({
  icon = 'bi bi-x-circle',
  title = 'Algo salió mal',
  text = 'No pudimos obtener la información en este momento. Intenta recargando la página o vuelve a intentarlo más tarde.',
  primaryCallback,
  secondaryCallback
}) => {
  const handlePrimaryClick = () => {
    if (primaryCallback) {
      primaryCallback();
    }
  };
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        zIndex: 1000
      }}>
      <NotificationMessage
        icon={icon}
        title={title}
        text={text}
        primaryCallback={handlePrimaryClick}
        secondaryCallback={secondaryCallback}
      />
    </div>
  );
};
